




























































































































import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Vue from "vue";
import SteppedSlider from "../common/SteppedSlider.vue";
import 'vue-slider-component/theme/default.css';
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import PresetScoringKeys from "@/utils/PresetScoringKeys";
import _ from 'lodash';
import Decisions from "@/store/modules/Decisions";

const workspaceOptionsModule = getModule(WorkspaceOptions);
const decisionsModule = getModule(Decisions)
@Component({
    components: {SteppedSlider}
})

export default class ScoreSliderKey extends Vue {

    @Model('newScoreValue')
    score!: number;

    @Prop()
    scoringKeys!: any[];

    @Prop({default: false})
    disabled!: boolean

    @Prop({default: false, type: Boolean})
    scoreBar!: boolean;

    @Prop({default: true, type: [Boolean, String]})
    thumbLabel!: boolean | string;

    @Prop({default: false, type: Boolean})
    hideCaptions!: boolean;

    @Prop()
    loading!: boolean

    @Prop()
    invalidated!: boolean;

    @Prop({default: 200, type: Number})
    width!: number;

    get barWidth() {
        return this.width - 44;
    }

    get keyWidth(){
        return this.width - 54;
    }
    
    private ratingIndex = 0;

    mounted() {
        if(this.showIconScoring) {
            this.onChangeScore();
        }
    }

    get selectedScoringKey() {
        if (this.scoringKeys) {
            let scoringKeys = this.scoringKeys
            let filteredSortedScoringKeys = scoringKeys.filter(sk => sk.upperLimit >= this.score)
                .sort((a, b) => a.upperLimit - b.upperLimit)

            if (filteredSortedScoringKeys.length > 0) {
                return filteredSortedScoringKeys[0];
            }
            return null;
        }
    }

    @Watch('score')
    private onChangeScore() {
       // let index = this.scoringKeys.findIndex((sk:any) => sk.upperLimit === this.score)
        let index = _.findIndex(this.scoringKeys, (sk:any)=> _.isEqual(sk,this.selectedScoringKey))
        this.ratingIndex = (index >= 0 ? this.scoringKeys.length-index-1: 0)
    }

    get scoreBarVisibility() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    get keysVisibility() {
        return workspaceOptionsModule.keysVisibility;
    }

    get showIconScoring() {
        return workspaceOptionsModule.showIconScoring
    }

    @Emit('newScore')
    @Emit('changed')
    @Emit('newScoreValue')
    private changeScore(newScore: number) {
        return newScore;
    }

    private changeRating(props: any) {
        if(this.scoringKeys.length <= 1) {
            return
        }
        if(this.scoringKeys.length === 2 ) {
            let index = _.findIndex(this.scoringKeys, (sk:any)=> _.isEqual(sk,this.selectedScoringKey))
            return this.changeScore(this.scoringKeys[Math.abs(-1 + index)].upperLimit)
        }
        else{
            if(props.index+1 === this.ratingIndex) {
                return this.changeScore(0)
            }
            return this.changeScore(this.scoringKeys[this.scoringKeys.length-2-props.index].upperLimit)
        }
    }

    // get color() {
    //     if(this.score < 0.33 && this.score >= 0) {
    //         return 'red'
    //     }
    //     if(this.score >= 0.33 && this.score <0.66) {
    //         return 'yellow'
    //     }
    //      if(this.score >= 0.66 && this.score <= 1) {
    //         return 'green'
    //     }
    // }

    get iconFromName() {
        let names = this.scoringKeys.map((key: any)=> {return key.name});
        let name = this.selectedScoringKey.name 
        //If hearts
        if(names.every(keyName => keyName.includes('\u2764\ufe0f ') || keyName === '')) {
            return {half: 'mdi-heart-half-full', full:'mdi-heart', empty:'mdi-heart-outline'}
        }

        //If checkbox with checkmarl
        if(names.every(keyName => keyName.includes('\u2611') || keyName.includes('\u2610'))){
                return  {full:'mdi-checkbox-marked', empty:'mdi-checkbox-blank-outline', half: 'mdi-checkbox-marked'}
        }

        //If ballotbox
         if(names.every(keyName => keyName.includes('\u2612') || keyName.includes('\u2610'))){
                return  {full:'mdi-checkbox-blank-off-outline', empty:'mdi-checkbox-blank-outline', half: 'mdi-checkbox-blank-off-outline'}
        }

        //If thumbs
        if(names.every(keyName => keyName.includes("\uD83D\uDC4E") || keyName.includes("\uD83D\uDC4D"))) {
            return {full:'mdi-thumb-up', empty:'mdi-thumb-down', half: 'mdi-thumb-up'}
        }

        //If stars
        if(names.every(keyName => keyName.includes('\u2605') || keyName.includes('\u2606')))
            return {half: 'mdi-star-half-full', full:'mdi-star', empty:'mdi-star-outline'}
    }

    get scoringSuffix() {
        if(workspaceOptionsModule.customRangeActive)
            return decisionsModule.scoringSuffix
        else
            return '%'
    }

    get scoringRangeMax() {
        if(workspaceOptionsModule.customRangeActive)
            return decisionsModule.scoringRangeMax
        else
            return 100
    }
}
